<div class="cpm-backdrop">
  <div class="cpm-card" role="dialog" aria-modal="true" aria-labelledby="cpm-title">
    <div class="cpm-icon">
      <i class="bx bx-store-alt"></i>
    </div>

    <h2 class="cpm-title" id="cpm-title">Choose how you'll take orders</h2>
    <p class="cpm-subtitle">
      Your menu, hours and profile are ready to edit. To start taking orders, enable Fork &amp; Find
      or connect your existing POS.
    </p>

    <ul class="cpm-options">
      <li class="cpm-option">
        <span class="cpm-option-icon"><i class="bx bx-check-shield"></i></span>
        <span class="cpm-option-text">
          <b>Fork &amp; Find</b> — take orders through Fork &amp; Find. Our support team activates
          your restaurant within 1-2 working days.
        </span>
      </li>
      @if (canConnectPos) {
        <li class="cpm-option">
          <span class="cpm-option-icon"><i class="bx bx-link"></i></span>
          <span class="cpm-option-text">
            <b>Square / Clover / Swirepay</b> — keep your POS; your menu syncs from it.
          </span>
        </li>
      }
    </ul>

    <div class="cpm-actions">
      <button
        type="button"
        class="btn btn-neutral rounded-3"
        [disabled]="loading"
        (click)="later.emit()"
      >
        Later
      </button>
      @if (canConnectPos) {
        <button
          type="button"
          class="btn btn-neutral rounded-3"
          [disabled]="loading"
          (click)="connectPos.emit()"
        >
          Connect a POS
        </button>
      }
      <button
        type="button"
        class="btn btn-dark rounded-3"
        [disabled]="loading"
        (click)="enableFnf.emit()"
      >
        @if (loading) {
          Enabling...
        } @else {
          Enable Fork &amp; Find
        }
      </button>
    </div>
  </div>
</div>
